import { getDefaultClipboardItem } from '@root/resources/file/file.helpers';
import { escapeCSV } from '@root/utils/Export';

const getClipboardItem = (doc) => getDefaultClipboardItem({
  content: `Subject: ${doc.content.subject}\nBody: ${doc.content.emailBody}`,
});

const getCsvContent = (docs) => docs.reduce((csv, doc) => {
  const { subject, emailBody } = doc.content;

  return `${csv}"${escapeCSV(subject?.trim())}","${escapeCSV(
    emailBody?.trim(),
  )}"\r\n`;
}, '');

const getPdfContent = (docs) => docs.reduce((pdf, doc) => {
  const { subject, emailBody } = doc.content;

  return `${pdf}\n\n${subject?.trim()}\n${emailBody?.trim()}\r\n`;
}, '');

const getTxtContent = (docs) => docs.reduce((txt, doc) => {
  const { subject, emailBody } = doc.content;

  return `${txt}\n\n${subject?.trim()}\n${emailBody?.trim()}\r\n`;
}, '');

export {
  getTxtContent, getPdfContent, getCsvContent, getClipboardItem,
};
